/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentRequest } from './search-equipment-request';


export interface EquipmentScheduleAssignmentsByFilterRequest { 
    scheduleId?: string;
    filter?: SearchEquipmentRequest;
}

